import styled from "styled-components";

const Container = styled.div`
  display: flex;
  padding: 4px 12px;
  align-items: center;
  justify-content: center;
  width: 180px; /* Increased from 132px to accommodate longer text */
  height: 22px;
  border-radius: 100px;
  background: #fff9e3;
  color: #000;

  font-size: var(--font-size-base);
  font-weight: 700;
  line-height: 22.4px;
`;

const Badge = ({ text }: { text: string }) => {
  return <Container>{text}</Container>;
};

export default Badge;